import { updateObject } from 'store/utility';
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    shareObjects: {
        showMode: "none",
        showOverlay: false,
        showHistoryBox: false,
        shareHistory: {
            showOverlay: false
        },
        shareColor: {
            darkMode: false
        },
        shareFontSize: {
            storeCount: 0
        },
        shareSearchList: {},
        shareUpload: {},
        shareDataForm: {},
        shareSplash: {},
        shareStatistic: {},
        shareTopStatistics: {},
    },
}
const ShareReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SHARE_UPDATE_SHAREOBJECTS_START:
            return { loading: true };
        case actionTypes.SHARE_UPDATE_SHAREOBJECTS_SUCCESS:
            return { loading: false, shareObjects: { ...state.shareObjects, ...action.payload } }
        case actionTypes.SHARE_SET_LOADING:
            return { ...state, loading: action.payload }
        case actionTypes.SHARE_SET_INIT_SHAREOBJECTS:
            return { ...INITIAL_STATE };
        default:
            return state;
    }
}

export default ShareReducer;